import { computed, inject, Injectable, resource } from '@angular/core';
import { ProofCtBatch } from '@ps-gui/claims-terminal-shared';
import { lastValueFrom } from 'rxjs';
import { PersonenschadenApiService } from '../../service/api/personenschaden-api.service';
import { CtBatchStoreService } from '../../service/app-state/ct-batch-store.service';

@Injectable({
  providedIn: 'root',
})
export class Proof301OverviewService {
  private readonly ctBatchStoreService = inject(CtBatchStoreService);
  private readonly proofApiService = inject(PersonenschadenApiService);

  readonly overview = resource({
    params: () => ({ auditId: (this.ctBatchStoreService.ctBatch as ProofCtBatch).auditId }),
    loader: async ({ params: { auditId } }) =>
      auditId != null
        ? lastValueFrom(this.proofApiService.get301DataSummary(auditId))
        : Promise.reject(),
  });

  readonly isNotEmpty = computed(() => {
    if (!this.overview.hasValue()) return false;
    const overview = this.overview.value();
    return overview.drgs.length > 0 || overview.diagnoseCount > 0 || overview.opsCount > 0;
  });
}
